var _style, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageCenterIconActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 23",
    width: 25,
    height: 23,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MessageCenterIconActive-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { opacity: .7;fill: #ffffff } \n\t\t.s1 { fill: #ffffff } \n\t\t.s2 { fill: none;stroke: #ffffff;stroke-width: 2 } \n\t\t.s3 { fill: #00a3c9 } \n\t\t.s4 { fill: #b4effd } \n\t\t.s5 { opacity: .4;fill: #ffa800 } \n\t\t.s6 { opacity: .2;fill: #ffa800 } \n\t\t.s7 { opacity: .6;fill: #ffa800 } \n\t\t.s8 { fill: #ffa800 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m9.5 11.5h12.9c1.7 0 3 1.4 3 3v5.5c0 1.7-1.3 3-3 3h-9.9c-1.6 0-3-1.3-3-3z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m5 7h12.9c1.6 0 3 1.3 3 3v5.5c0 1.6-1.4 3-3 3h-9.9c-1.7 0-3-1.4-3-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m5 7h12.9c1.6 0 3 1.3 3 3v5.5c0 1.6-1.4 3-3 3h-9.9c-1.7 0-3-1.4-3-3z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m5.5 11c-3 0-5.5-2.5-5.5-5.5 0-3 2.5-5.5 5.5-5.5 3 0 5.5 2.5 5.5 5.5 0 3-2.5 5.5-5.5 5.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s4",
    d: "m9 7.6c0 1.4-1.3 1.4-3 1.4q-0.3 0-0.5 0-0.2 0-0.5 0c-1.7 0-3 0-3-1.4 0-1 0.7-1.9 1.7-2.4q-0.3-0.5-0.3-1.1c0-1.2 0.9-2.1 2.1-2.1 1.2 0 2.1 0.9 2.1 2.1q0 0.6-0.3 1.1c1 0.5 1.7 1.4 1.7 2.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m12 16c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2 1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m9 16c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2 1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m15 16c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2 1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s8",
    d: "m18 16c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2 1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageCenterIconActive);
export default __webpack_public_path__ + "static/media/MessageCenterIconActive.51bad326108f9c8d09ce3d4e64b8e75f.svg";
export { ForwardRef as ReactComponent };